"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const sideBar_1 = require("components/cosmos/sideBar");
const useTimeoutValue_1 = __importDefault(require("hooks/useTimeoutValue"));
const mobx_react_1 = require("mobx-react");
const services_1 = require("modules/app/services");
const dripping_1 = require("modules/app/services/datahubEvents/dripping");
const drippingFormBody_1 = __importDefault(require("./drippingFormBody"));
const drippingFormFooter_1 = __importDefault(require("./drippingFormFooter"));
const drippingFormHeader_1 = __importDefault(require("./drippingFormHeader"));
const useDrippingForm_1 = require("./useDrippingForm");
const drippingForm_module_scss_1 = __importDefault(require("./drippingForm.module.scss"));
const OPEN_DELAY_TO_ALLOW_ANIMATION_TO_RUN = 10;
const mapStateToProps = (stores) => ({
    drippings: stores.DrippingStore.items
});
const DrippingFormSidebar = ({ onSave, onClose, dripping, drippings, isBulkOperation = false }) => {
    (0, react_1.useEffect)(() => {
        if (!dripping) {
            services_1.DatahubEventsService.sendEvent({
                schema: new dripping_1.ViewCreateDrippingSchema({
                    arrivedFrom: services_1.ArrivedFrom.NEW_DRIPPING_BUTTON,
                    concept: 'OLD'
                })
            });
        }
    }, [dripping]);
    const { handleClose, handleSave, saveButtonTitle } = (0, useDrippingForm_1.useDrippingForm)({
        isBulkOperation,
        dripping,
        onSave,
        onClose
    });
    const isOpen = (0, useTimeoutValue_1.default)(false, true, OPEN_DELAY_TO_ALLOW_ANIMATION_TO_RUN);
    return ((0, jsx_runtime_1.jsxs)(sideBar_1.Sidebar, { isOpen: isOpen, onClose: handleClose, className: drippingForm_module_scss_1.default.sidebar, children: [(0, jsx_runtime_1.jsx)(sideBar_1.Sidebar.Header, { className: (0, classnames_1.default)('_border-bottom _border-gray-200 _p-2', drippingForm_module_scss_1.default.sidebarHeader), children: (0, jsx_runtime_1.jsx)(drippingFormHeader_1.default, { isBulkOperation: isBulkOperation, handleClose: handleClose, dripping: dripping }) }), (0, jsx_runtime_1.jsxs)(sideBar_1.Sidebar.Body, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('_px-5 _pt-5 _pb-5', drippingForm_module_scss_1.default.sidebarContainer, {
                            [drippingForm_module_scss_1.default.withHeaderAlert]: isBulkOperation
                        }), children: (0, jsx_runtime_1.jsx)(drippingFormBody_1.default, { drippings: drippings, isBulkOperation: isBulkOperation, dripping: dripping }) }), (0, jsx_runtime_1.jsx)("footer", { className: (0, classnames_1.default)('_d-flex _justify-content-end _border-top _border-gray-20 _position-absolute _bg-white _w-full _p-5', drippingForm_module_scss_1.default.sidebarFooter), children: (0, jsx_runtime_1.jsx)(drippingFormFooter_1.default, { handleClose: handleClose, handleSave: handleSave, saveButtonTitle: saveButtonTitle }) })] })] }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingFormSidebar);
